"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = void 0;

var react_1 = __importDefault(require("react"));

var Spacer = function Spacer() {
  return react_1["default"].createElement("div", {
    className: "block pt-2 pb-2 md:pt-4 md:pb-4"
  }, "\xA0");
};

exports.Spacer = Spacer;